var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 125,
    viewBox: "0 0 164 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 33,
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 99,
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 91,
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 65,
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 20,
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 47,
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 73,
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 99,
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 99,
    width: 26,
    height: 26,
    fill: "#5ECC6B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.796b56bb8ab7034a7f51d950533a761d.svg";
export { ForwardRef as ReactComponent };